import * as React from "react";
import type { SVGProps } from "react";
const SvgAustrianAirlines = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 50 50"
    width="100%"
    height="100%"
    {...props}
  >
    <clipPath id="austrian-airlines_svg__a">
      <path d="M0 0h50v50H0z" />
    </clipPath>
    <g
      fill="#d81e05"
      fillRule="evenodd"
      clipPath="url(#austrian-airlines_svg__a)"
      clipRule="evenodd"
    >
      <path d="M5.465 33.294c6.619-5.363 11.345-9.959 12.753-12.45.599-.961.79-1.88.458-2.629-.617-1.393-2.797-1.816-5.486-1.293A209 209 0 0 1 49.771 12a.222.222 0 0 1 .076.433C34.262 17.498 20.074 25.706 8.02 36.323a.1.1 0 0 1-.052.026L.123 37.725c-.11.02-.168-.123-.08-.192a209 209 0 0 0 5.422-4.239" />
      <path d="M4.414 19.011q-.26.07-.524.146c-.103.027-.094.18.014.195l2.972.425 5.192.742q.03.003.059-.01c3.654-1.744 6.09-2.416 6.626-1.656.166.236.137.597-.057 1.066a5 5 0 0 1-.253.508c.57-.908.753-1.777.438-2.485-.59-1.318-2.672-1.718-5.248-1.221q-4.636 1.035-9.218 2.29" />
    </g>
  </svg>
);
export default SvgAustrianAirlines;
